import axios from 'axios';

interface WaitlistSignupData {
  email: string;
  company: string;
  role: string;
}

interface WaitlistResponse {
  success: boolean;
  message: string;
  member_number: number | null;
  spots_remaining: number | null;
}

interface SpotsResponse {
  total: number;
  taken: number;
  remaining: number;
  discount_percent: number;
}

export async function getWaitlistSpots(): Promise<SpotsResponse> {
  const res = await axios.get('/api/waitlist/spots');
  return res.data;
}

export async function submitWaitlistSignup(
  data: WaitlistSignupData
): Promise<WaitlistResponse> {
  const res = await axios.post('/api/waitlist/signup', data);
  return res.data;
}
